import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { Spacer } from 'components/Utility'
import { BlueButton, NavButton } from 'components/Button'
import { ProductContainer } from 'components/Product'

const ProductTemplate: FC = () => {
  const dispatch = useDispatch()
  const goToOrderPage = useCallback(() => dispatch(push('/product/order')), [dispatch])
  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <ProductContainer />
      <Spacer size={48} />
      <BlueButton label={'アプリでの並び順を確認する'} onClick={goToOrderPage} size={'medium'} type={'main'} />
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default ProductTemplate
